"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CompromisoConLaExcelencia() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="2602" id="compromiso-con-la-excelencia" className="bg-background text-foreground">
      {}
      <div className="relative grid grid-cols-1 md:grid-cols-2 min-h-screen md:h-screen overflow-hidden">
        {}
        <div aria-hidden="true" className="hidden md:block absolute left-1/2 top-0 -translate-x-1/2 w-px h-full z-20" style={{
        background: "linear-gradient(to bottom, hsl(45 100% 52%) 0%, hsl(45 100% 52%) 30%, hsl(222 47% 11%) 50%, hsl(215 15% 65%) 70%, hsl(215 15% 65%) 100%)"
      }} />

        {}
        <div ref={leftRef} className={`relative h-[60vh] md:h-full overflow-hidden transition-all duration-[1200ms] ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_vigilance.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_vigilance.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_security_vigilance.png-wvc-sizes" alt="Personal de seguridad profesional en vigilancia estratégica" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover scale-110" style={{
          transform: leftVisible ? "scale(1.1)" : "scale(1.15)",
          transition: "transform 1500ms ease-out"
        }} />
          {}
          <div aria-hidden="true" className="absolute inset-0" style={{
          background: "linear-gradient(135deg, hsl(220 15% 6% / 0.7) 0%, hsl(220 15% 6% / 0.4) 50%, hsl(222 47% 11% / 0.5) 100%)"
        }} />

          {}
          <div className="absolute top-6 left-6 md:top-10 md:left-10 z-10">
            <span className="font-mono text-[11px] md:text-xs tracking-[0.3em] uppercase" style={{
            color: "hsl(45 100% 52%)"
          }}>
              I. Disciplina
            </span>
          </div>

          {}
          <div className="absolute bottom-8 left-6 right-6 md:bottom-12 md:left-10 md:right-10 z-10">
            <p className="font-serif italic text-2xl md:text-[32px] leading-tight max-w-md" style={{
            color: "hsl(0 0% 100%)"
          }}>
              Donde la vigilancia se vuelve instinto.
            </p>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative h-[60vh] md:h-full overflow-hidden transition-all duration-[1200ms] ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`} style={{
        backgroundColor: "hsl(215 15% 95%)"
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_tech_monitoring.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_tech_monitoring.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1697018/img/poseidon_tech_monitoring.png-wvc-sizes" alt="Centro de monitoreo tecnológico avanzado con pantallas de alta resolución" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" style={{
          transform: rightVisible ? "scale(1.1)" : "scale(1.15)",
          transition: "transform 1500ms ease-out"
        }} />
          {}
          <div aria-hidden="true" className="absolute inset-0" style={{
          background: "linear-gradient(225deg, hsl(0 0% 100% / 0.4) 0%, hsl(215 15% 95% / 0.25) 50%, hsl(0 0% 100% / 0.55) 100%)"
        }} />

          {}
          <div className="absolute top-6 right-6 md:top-10 md:right-10 z-10">
            <span className="font-mono text-[11px] md:text-xs tracking-[0.3em] uppercase" style={{
            color: "hsl(220 15% 6%)"
          }}>
              II. Tecnología
            </span>
          </div>

          {}
          <div className="absolute bottom-8 left-6 right-6 md:bottom-12 md:left-10 md:right-10 z-10 text-right">
            <p className="font-serif italic text-2xl md:text-[32px] leading-tight max-w-md ml-auto" style={{
            color: "hsl(220 15% 6%)"
          }}>
              Donde la protección se vuelve absoluta.
            </p>
          </div>
        </div>
      </div>

      {}
      <div ref={bodyRef} className={`px-6 md:px-8 pt-20 md:pt-32 pb-24 md:pb-40 transition-all duration-1000 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mx-auto max-w-[720px] text-center">
          <div className="mb-8 flex items-center justify-center gap-4">
            <span className="h-px w-12 bg-border" />
            <span className="font-mono text-[10px] md:text-xs tracking-[0.4em] uppercase text-muted-foreground">
              Filosofía POSEIDÓN
            </span>
            <span className="h-px w-12 bg-border" />
          </div>
          <p className="font-default text-xl md:text-2xl leading-[1.5] md:leading-[1.55] text-foreground">
            POSEIDÓN opera en el punto exacto donde la disciplina humana se encuentra con la 
            precisión tecnológica. Creemos que la seguridad no es un producto, sino un estado 
            forjado en el rigor del entrenamiento y perfeccionado mediante inteligencia 
            estratégica. Aquí, la vigilancia activa, el monitoreo de vanguardia y la 
            respuesta táctica convergen en una sola disciplina inquebrantable. No somos 
            solo una agencia; somos el escudo diseñado para quienes exigen excelencia.
          </p>
        </div>
      </div>
    </section>;
}